<template>
    <div class=".container">
        <div class="p-2">
            ※種族値の間違い、バグ等の問題が発生した場合、当サイトの運営アカウント
            <span>( ポケモン ステータス計算機 【素早さ自動調整機能付き】 運営：<a class="link" href="https://twitter.com/pokesuba_calc_O" target="_blank" rel="noopener noreferrer">@pokesuba_calc_O</a> )</span>
            、または、制作者 兼 管理人
            <span>( Algo05：<a class="link" href="https://twitter.com/algo05_pokemon" target="_blank" rel="noopener noreferrer">@algo05_pokemon</a> )</span>
            へ、直前の詳細な作業内容とともにご報告いただけますと幸いです。
        </div>
    </div>
</template>

<style scoped>
.link {
    color: #ffa534;
}
.link:hover {
    color: red;
}
</style>